import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import React, {useState} from "react";
import * as UserService from "../../api/UserService";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import MentorReferralProgramCodeData from "./MentorReferralProgramCodeData";
import Banner from "./Banner";
import {useTranslation} from "react-i18next";

function MentorReferralProgramPage() {

    const [referralData, setReferralData] = useState(undefined)
    const [callingPost, setCallingPost] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'mentorReferralProgramPage' });

    function getReferralData() {
        UserService.fetchReferralData(handleGetApiResponse, () => {window.alert("Failed to fetch")})
    }
    function handleGetApiResponse(response) {
        setReferralData(response)
    }

    function handlePostApiResponse() {
        getReferralData()
        setCallingPost(false)
    }

    useEffectOnce(() => {
        getReferralData()
    })

    function callJoinRefProgram() {
        setCallingPost(true)
        UserService.requestReferralCode(handlePostApiResponse, () => {
            window.alert("Failed to request")
            setCallingPost(false)
        })

    }

    return (
        <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                {referralData?.length === 0 &&
                    <div>
                        <div className={Style.h5Heading}>{t('notAMember')}</div>
                        <button disabled={callingPost} className={cabinetStyle.changePasswordButton} onClick={callJoinRefProgram}>{t('join')}</button>
                        <br/>
                        <small>{t('clickToJoin')}</small>
                        <br/>
                        <a href={"/referral_agreement"} target={"_blank"}>{t('andAgree')}</a>
                    </div>
                }
                {referralData?.length > 0 && referralData.map((singleCodeData) => {
                    return (
                        <MentorReferralProgramCodeData key={singleCodeData.code} {...singleCodeData}/>
                    )
                })}
            </div>
        </>
    )
}

export default MentorReferralProgramPage